import { Box, Typography } from "@mui/material";
import { QuoteItem } from "../../models/QuoteItem";
import { StyledQuoteItemsCard } from "./QuoteItemCard.styled";
import { CheckIcon, PencilSimpleIcon, TrashSimpleIcon, XIcon } from "@phosphor-icons/react";
import { useTextFormatter } from "../../hooks/useTextFormatter";
import { useState } from "react";

type QuoteItemCardProps = {
  position: number;
  quoteItem: QuoteItem;
  onEdit: (quoteItem: QuoteItem) => void;
  onRemove: (quoteItemId: number) => void;
};

export const QuoteItemCard = ({
  position,
  quoteItem,
  onEdit,
  onRemove
}: QuoteItemCardProps) => {
  const { renderText } = useTextFormatter();
  const [confirmation, setConfirmation] = useState<boolean>(false);

  const handleRemove = () => {
    onRemove(quoteItem.id);
    setConfirmation(false);
  }

  return (
    <StyledQuoteItemsCard>
      <Box className="position">
        <Typography variant="h4" className="position">
          {position + 1}
        </Typography>
      </Box>
      <Box className="description">
        <Typography variant="h4">
          {renderText(quoteItem.description)}
        </Typography>
        <Box className="actions">
          {confirmation ? (
            <>
              <CheckIcon size={24} weight="bold" onClick={handleRemove}/>
              <XIcon size={24} weight="bold" onClick={() => setConfirmation(false)}/>
            </>
          ) : (
            <>
              <PencilSimpleIcon
                size={24}
                weight="bold"
                onClick={() => onEdit(quoteItem)}
              />
              <TrashSimpleIcon
                size={24}
                weight="bold"
                onClick={() => setConfirmation(true)}
              />
            </>
          )}
        </Box>
      </Box>
      <Box className="total">
        <Typography variant="h4">&#8364;</Typography>
        <Typography variant="h4">
          {Number(quoteItem.price).toFixed(2)}
        </Typography>
      </Box>
    </StyledQuoteItemsCard>
  );
};
